<template>
  <BaseAutoCompleteWithSingleSelectedItem
    v-model="modelValue"
    :label="i18n.global.t('pages.selectRole.selectRoleLabel')"
    itemName="organization_name"
    :items="items"
    :initial-item-id="props.initialRoleId"
    :errorMessages="props.errorMessages"
    :clearable="false"
    selectFirstIfOnlyOne
  />
</template>
<script setup lang="ts">
import i18n from '@/lang/i18n';
import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import Role from '@/types/SelfRole';
import { onMounted, ref, computed } from 'vue';
import SelectRoleChecker from '@/router/selectRoleChecker';

const props = defineProps<{
  modelValue: Role | undefined;
  initialRoleId?: number;
}>();

const emit = defineEmits(['update:modelValue']);

const items = ref<Role[]>([]);

onMounted(() => {
  SelectRoleChecker
    .getSelfRoles()
    .then((data) => {
      items.value = data;
      setModelValue()
    });
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  let filteredItems = items.value;
  modelValue.value = filteredItems.filter((item) => {
    return item.id === props.initialRoleId
  })[0];
}
</script>
